import { Box, HStack } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { SeV2QuestionStatus } from "../../../autogen/bff-api";

const STATUS_COLORS: Record<SeV2QuestionStatus, { bg: string; fg: string }> = {
  [SeV2QuestionStatus.Unanswered]: { bg: "smChipAmberBg", fg: "smChipAmberFg" },
  [SeV2QuestionStatus.Answered]: { bg: "smChipTealBg", fg: "smChipTealFg" },
  [SeV2QuestionStatus.Published]: { bg: "smChipGreenBg", fg: "smChipGreenFg" },
};

export const useQuestionStatusLabel = () => {
  const { t } = useTranslation();
  return (status: SeV2QuestionStatus): string => {
    switch (status) {
      case SeV2QuestionStatus.Unanswered:
        return t("Awaiting answer");
      case SeV2QuestionStatus.Answered:
        return t("Answered");
      case SeV2QuestionStatus.Published:
        return t("Published to all tenderers");
    }
  };
};

export const QuestionStatusChip = ({ status }: { status: SeV2QuestionStatus }) => {
  const getLabel = useQuestionStatusLabel();
  const colors = STATUS_COLORS[status];
  return (
    <HStack
      as="span"
      display="inline-flex"
      spacing="1.5"
      bg={colors.bg}
      color={colors.fg}
      rounded="full"
      px="2.5"
      py="0.5"
      fontSize="xs"
      fontWeight="semibold"
      flexShrink={0}
    >
      <Box as="span" w="1.5" h="1.5" rounded="full" bg="currentColor" />
      <Box as="span">{getLabel(status)}</Box>
    </HStack>
  );
};
